module.exports = "dist/images/components-button-controls-basic.b11a0a1.png";